var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        ref: "table",
        attrs: {
          columns: _vm.columnsConfig,
          paginationOptions: _vm.paginationOptions,
          searchOptions: _vm.searchOptions,
          sortOptions: _vm.sortOptions,
          mode: _vm.vgtManager ? "remote" : "records",
          rows: _vm.groupsForFeature,
          isLoading: _vm.vgtManager && _vm.vgtManager.isLoading,
          totalRows: _vm.vgtManager
            ? _vm.vgtManager.results.totalRows
            : _vm.groupsForFeature.length
        },
        on: {
          "on-page-change": function($event) {
            _vm.vgtManager &&
              _vm.vgtManager.pageEvent.bind(_vm.vgtManager)($event)
          },
          "on-sort-change": function($event) {
            _vm.vgtManager &&
              _vm.vgtManager.sortEvent.bind(_vm.vgtManager)($event)
          },
          "on-column-filter": function($event) {
            _vm.vgtManager &&
              _vm.vgtManager.filterEvent.bind(_vm.vgtManager)($event)
          },
          "on-per-page-change": function($event) {
            _vm.vgtManager &&
              _vm.vgtManager.perPageEvent.bind(_vm.vgtManager)($event)
          },
          "on-search": function($event) {
            _vm.vgtManager &&
              _vm.vgtManager.searchEvent.bind(_vm.vgtManager)($event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "table-row",
              fn: function(props) {
                return [
                  props.column.isActions
                    ? _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          _vm._t("actionsBefore", null, {
                            group: _vm.groupsForFeatureById.get(props.row.id)
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.onEdit(props.row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-pen" })]
                          ),
                          _vm._v(" "),
                          _vm.canDeleteGroups
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-danger",
                                  on: {
                                    click: function($event) {
                                      return _vm.onDelete(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-dumpster" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("actionsAfter", null, {
                            group: _vm.groupsForFeatureById.get(props.row.id)
                          })
                        ],
                        2
                      )
                    : _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(props.formattedRow[props.column.field]) +
                            "\n      "
                        )
                      ])
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-primary mt-1", on: { click: _vm.onAdd } },
        [_c("i", { staticClass: "fa fa-plus" })]
      ),
      _vm._v(" "),
      _vm._t(
        "editModal",
        function() {
          return [
            _c("EditModal", {
              ref: "editmodal",
              attrs: {
                availableSalutations: _vm.availableSalutations,
                allUsers: _vm.users,
                groupSelector: _vm.groupSelector,
                groupCopyFunction: _vm.groupCopyFunction,
                groupSaveFunction: _vm.groupSaveFunction,
                allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "editModalTitle",
                    fn: function() {
                      return [_vm._t("editModalTitle")]
                    },
                    proxy: true
                  },
                  {
                    key: "generalAfter",
                    fn: function({ group }) {
                      return [_vm._t("generalAfter", null, { group: group })]
                    }
                  },
                  {
                    key: "userButtonsBefore",
                    fn: function({ groupUser }) {
                      return [
                        _vm._t("userButtonsBefore", null, {
                          groupUser: groupUser
                        })
                      ]
                    }
                  },
                  {
                    key: "userButtonsAfter",
                    fn: function({ groupUser }) {
                      return [
                        _vm._t("userButtonsAfter", null, {
                          groupUser: groupUser
                        })
                      ]
                    }
                  },
                  {
                    key: "externalUserButtonsBefore",
                    fn: function({ groupUserExternal }) {
                      return [
                        _vm._t("externalUserButtonsBefore", null, {
                          groupUserExternal: groupUserExternal
                        })
                      ]
                    }
                  },
                  {
                    key: "externalUserButtonsAfter",
                    fn: function({ groupUserExternal }) {
                      return [
                        _vm._t("externalUserButtonsAfter", null, {
                          groupUserExternal: groupUserExternal
                        })
                      ]
                    }
                  },
                  {
                    key: "selectedExternalUserButtonsBefore",
                    fn: function({ groupUserExternals }) {
                      return [
                        _vm._t("selectedExternalUserButtonsBefore", null, {
                          groupUserExternals: groupUserExternals
                        })
                      ]
                    }
                  },
                  {
                    key: "selectedExternalUserButtonsAfter",
                    fn: function({ groupUserExternals }) {
                      return [
                        _vm._t("selectedExternalUserButtonsAfter", null, {
                          groupUserExternals: groupUserExternals
                        })
                      ]
                    }
                  },
                  {
                    key: "externalUserSelectModalTabs",
                    fn: function() {
                      return [_vm._t("externalUserSelectModalTabs")]
                    },
                    proxy: true
                  },
                  {
                    key: "editModalTabs",
                    fn: function({ group }) {
                      return [_vm._t("editModalTabs", null, { group: group })]
                    }
                  }
                ],
                null,
                true
              )
            })
          ]
        },
        {
          availableSalutations: _vm.availableSalutations,
          allUsers: _vm.users,
          setRef: el => (_vm.$refs.editmodal = el)
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }